const stylesheet = 'my-2 w-full border-t border-semantic-border';

export function SidebarSeparator() {
  return <hr className={stylesheet} />;
}
